<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            prop="termsName"
            label="条款名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="termsUpdateTime"
            label="最近修改时间"
            width="180">
    </el-table-column>
    <el-table-column
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "TermsTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      update(id){
        this.$emit("update",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
